import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { listSearchSchema } from '@/lib/list-search-schema';
import Invoices from '@/pages/Invoices';

export const invoicesSearchSchema = listSearchSchema.extend({
  status: z.string().optional(),
});

export type InvoicesSearch = z.infer<typeof invoicesSearchSchema>;

export const Route = createFileRoute('/_authenticated/invoices/')({
  validateSearch: invoicesSearchSchema,
  component: Invoices,
});
